<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.seller">
  <div *ngIf="wrappers">
    <div class="row" *ngIf="wrappers.length == 0">
      <div class="col-md-12" style="text-align:center;margin-top:10px">
        <div style="font-size: 25px;">{{localService.languageContent.seller.no_business}}</div>
        <br />
        <button class="button_icon button_icon_color icon_adjust" style="font-size: 100px;margin-left: 10px;"
          (click)="onRoute('',1)">add_circle_outline</button>
      </div>
      <div style="text-align: center;">
        <span>Or</span>
        <app-clone-business />
      </div>
    </div>
    <div *ngIf="wrappers.length > 0">
      <div class="row">
        <div class="col-md-4">
        </div>
        <div class="col-md-4">
          <div style="text-align:right;">
            <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;"
              (click)="onGenerateBarCode()">qr_code_scanner</button>
            <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;"
              (click)="onRoute('',1)">add_circle_outline</button>
          </div>
        </div>
        <div class="col-md-4">
        </div>
      </div>
      <div *ngFor="let item of wrappers">
        <div class="row">
          <div class="col-md-4">
          </div>
          <div class="col-md-4">
            <div class="banner" style="margin-bottom:20px;height:auto;">
              <div *ngIf="item.v7 != '0'" style="text-align:center" [ngClass]="localService.getLanguageCode(item.v4)">
                {{item.v3}}</div>
              <app-qrcode-generator [value]="item.key" [businessId]="item.key" [categoryCode]="categoryCode"
                [countryCode]="localService.selected.countryCode" [title]="item.v7 == '0' ? item.v3 : ''"
                (onTitleClicked)="onRoute(item.key,1)" [isShowLabelPrint]="true" />
              <div>
                <div *ngIf="!(item.v6 != '0' || item.v7 != '0')">
                  <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;"
                    (click)="onRoute(item.key,7)">share</button>
                  <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;"
                    (click)="onRoute(item.key,6)">shopping_bag</button>
                  <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;"
                    (click)="onRoute(item.key,2)">shopping_cart</button>
                  <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;"
                    (click)="onRoute(item.key,3)">format_list_numbered</button>
                  <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;"
                    (click)="onRoute(item.key,4)">playlist_add_check</button>
                  <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;"
                    (click)="onRoute(item.key,5)">label</button>
                  <button *ngIf="item.v2 == '1'" class="button_icon delete_icon icon_adjust"
                    style="margin-left: 10px;float: right;" (click)="onActiveInactiveStatus(item.key)">cancel</button>
                </div>
                <div style="color:red;text-align: center;" *ngIf="item.v6 != '0' || item.v7 != '0'">
                  <span *ngIf="item.v7 != '0'">{{localService.languageContent.seller.blocked}}&nbsp;;</span>
                  <button class="btn btn-primary" *ngIf="item.v6 != '0'" style="z-index:1"
                    title="{{localService.languageContent.seller.buy_plan}}" (click)="onRoute(item.key, 8)">
                    {{localService.languageContent.seller.buy_plan}}
                  </button>
                  <span *ngIf="item.v6 != '0'">&nbsp;{{localService.languageContent.seller.suspended}}&nbsp;</span>
                  <a class="button" *ngIf="item.v6 != '0'" [routerLink]="['/prepaid',ctryCode,userId,2,item.key]">
                    <i class="material-icons button icon_adjust">account_balance_wallet</i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-business-deductive [businesses]="localService.loggedMember.businesses"
    (onBusinessUpdated)="onBusinessUpdated($event)"></app-business-deductive>
</div>
<div>
  <app-otp-container *ngIf="isShowOtpPopup" [IsOtpPopup]="true" (onVerified)="onVerifiedOtp($event)"
    [businessId]="selectedBusinessId" [otpType]="12" [interactionType]="interactionType"
    (onCancelled)="isShowOtpPopup = false" />
</div>